export const navControl = {
  state: {
    // 不展示导航(三种)的路由
    notShowNavFixed: [
      'logInSelection', 
      'signUp', 
      'logInSelection', 
      'logInByAccount', 
      'workPost', 
      'authorPost', 
      'collectionPost',
      'xctAlbum',
      'xcTime',
      'xctAlbums',
      'userMsg',
    ],
    notShowNavMain: [
      'startQuiz'
    ],
    notShowNavChanger: [
      'workPost', 
      'authorPost', 
      'collectionPost', 
      'userMsg',
      'xctAlbum',
      'xcTime',
      'xctAlbums',
    ]
  },
  mutations: {

  },
  actions: {

  },
  getters: {
    notShowNavFixed: state => state.notShowNavFixed,
    notShowNavMain: state => state.notShowNavMain,
    notShowNavChanger: state => state.notShowNavChanger
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nav-control/index.js